var _path, _path2, _path3, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnDashboardWireless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1448 20.5C50.1448 21.4133 50.1863 22.47 50.1699 23.6301C45.6412 19.5563 36.5532 16.5001 30.1857 16.5001C23.8307 16.5001 14.8089 19.5299 10.1999 23.7001C10.0938 22.7005 10.0938 21.3295 10.1448 20.5284C21.004 10.2476 39.3473 10.3667 50.1448 20.5Z",
    fill: "url(#paint0_linear_3063_73130)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0001 27.9761C43.1026 28.8667 43.1889 30.3119 43.2001 31.3601C39.5001 28.5001 34.1579 26.5 30.0271 26.5C25.9042 26.5 21 28.0001 17.2001 31.4001C17.0985 30.5808 17.0312 28.743 17.05 28C24.9688 21.3038 36.3869 21.7136 43.0001 27.9761Z",
    fill: "url(#paint1_linear_3063_73130)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0537 35.898C35.1197 36.491 35.1545 37.6722 35.1999 38.3002C33.6453 36.6504 31.2008 36.5003 29.4651 36.5003C27.7329 36.5003 25.7965 36.439 24.2 38.4002C24.0731 37.8336 23.9817 36.4631 24.0127 36.039C26.1515 32.9044 32.7558 32.777 35.0537 35.898Z",
    fill: "url(#paint2_linear_3063_73130)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3063_73130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1827 23.6411C48.9919 24.7362 47.7826 25.8255 46.5548 26.9433C42.026 22.8695 36.5532 20.7419 30.1858 20.7419C23.8307 20.7419 18.3518 22.8298 13.7428 27C12.552 25.8823 11.3735 24.7759 10.1827 23.6695C21.0419 13.3887 39.3853 13.5078 50.1827 23.6411Z",
    fill: "#B4E2FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3063_73130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1827 31.3678C24.5428 24.0031 36.416 24.4234 43.1827 31.3616C43.1196 31.4243 43.0754 31.5058 43.006 31.5748C41.9014 32.6726 40.7967 33.7705 39.7173 34.8808C39.5532 35.0439 39.4585 35.0251 39.3134 34.8808C37.5144 33.093 35.3493 31.9701 32.8623 31.4933C31.2211 31.1796 29.5736 31.1608 27.9261 31.4306C25.5969 31.8132 23.5391 32.7667 21.7402 34.266C21.4435 34.5107 21.1721 34.793 20.9385 35C19.6761 33.7705 18.4389 32.5786 17.1954 31.3678H17.1827Z",
    fill: "#B4E2FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_3063_73130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6645 44C28.7786 43.1056 27.9116 42.2048 27.0384 41.3105C26.1335 40.3969 25.2412 39.4833 24.33 38.5762C24.1465 38.3909 24.1212 38.2759 24.33 38.0907C27.3358 35.3117 32.0121 35.3053 35.0053 38.0587C35.2267 38.2568 35.2521 38.359 35.0179 38.5953C33.2714 40.3586 31.5439 42.1282 29.8037 43.8978C29.7847 43.9169 29.7531 43.9361 29.6708 43.9936L29.6645 44Z",
    fill: "#B4E2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3063_73130",
    x: 10.1827,
    y: 15.5,
    width: 40,
    height: 11.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.517647 0 0 0 0 0.890196 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3063_73130"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3063_73130",
    x: 17.1827,
    y: 25.5,
    width: 26,
    height: 9.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.517647 0 0 0 0 0.890196 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3063_73130"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_3063_73130",
    x: 24.1827,
    y: 35.5,
    width: 11,
    height: 8.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.517647 0 0 0 0 0.890196 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3063_73130"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3063_73130",
    x1: 10.1057,
    y1: 18.35,
    x2: 50.1827,
    y2: 18.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96D3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65B0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3063_73130",
    x1: 17,
    y1: 27.5,
    x2: 43,
    y2: 27.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97D4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65B0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3063_73130",
    x1: 23.9917,
    y1: 35.7504,
    x2: 34.9159,
    y2: 35.7504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97D4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65B0E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDashboardWireless);
export default __webpack_public_path__ + "static/media/icn_dashboard_wireless.a9cec37650e85bc925348c2dc5fee5a5.svg";
export { ForwardRef as ReactComponent };